module.exports = __webpack_public_path__ + "img/capability-img_1.6a6ba73.jpg";